import client from "./client";

// عملات ومعايير محاسبية عالمية — يُستخدم عند إنشاء الفرع لاختيار النظام المحاسبي.
export const listCurrencies = async () => (await client.get("/gl/currencies")).data;
export const listStandards = async () => (await client.get("/gl/standards")).data;
export const previewStandard = async (code) => (await client.get(`/gl/standards/${code}/preview`)).data;

// دليل حسابات · تصنيفات · مراكز تكلفة على مستوى الفرع.
const B = (id) => `/branches/${id}/gl`;
export const branchAccounts = async (branchId, kind) =>
  (await client.get(`${B(branchId)}/accounts`, { params: kind ? { kind } : {} })).data;
export const branchCategories = async (branchId, itemType) =>
  (await client.get(`${B(branchId)}/categories`, { params: itemType ? { item_type: itemType } : {} })).data;
export const branchCenters = async (branchId) => (await client.get(`${B(branchId)}/cost-centers`)).data;
export const addBranchCategory = async (branchId, body) =>
  (await client.post(`${B(branchId)}/categories`, body)).data;
export const updateBranchCategory = async (branchId, catId, body) =>
  (await client.patch(`${B(branchId)}/categories/${catId}`, body)).data;
export const deleteBranchCategory = async (branchId, catId) =>
  (await client.delete(`${B(branchId)}/categories/${catId}`)).data;
export const addBranchCenter = async (branchId, body) =>
  (await client.post(`${B(branchId)}/cost-centers`, body)).data;
export const deleteBranchCenter = async (branchId, centerId) =>
  (await client.delete(`${B(branchId)}/cost-centers/${centerId}`)).data;
